
import { customRUMSession } from "./rum-utility";

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    console.log('Service Worker is not supported in this browser');
    return;
  }

  window.addEventListener('VesselIMO', () => {
    console.log("*** VesselIMO Captured : Registering Service Worker ***");

    fetch('/version.json', {
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache' }
    })
      .then(response => {
        if (!response.ok) {
          console.error(`Failed to fetch version.json: ${response.status} ${response.statusText}`);
          return null;
        }
        return response.json();
      })
      .then(data => {
        if (!data) return;

        console.log('Current version:', data.version);
        sessionStorage.setItem('app_build_version', data.version);
        customRUMSession(); // record new version info

        navigator.serviceWorker.register(`./service-worker.js?v=${data.version}`)
          .then((registration) => {

            // ---- Detect new SW version ----
            registration.onupdatefound = () => {
              const newWorker = registration.installing;
              if (newWorker) {
                newWorker.onstatechange = () => {
                  if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                    console.log('New Service Worker available, prompting user...');
                    showUpdateBanner(newWorker);
                  } else if (newWorker.state === 'installed') {
                    console.log('Content cached for offline use.');
                  }
                };
              }
            };

            // ---- Send session data once SW is ready ----
            navigator.serviceWorker.ready.then(() => {
              const IMONumber = sessionStorage.getItem('vesselIMO') || "<IMO>";
              const username = sessionStorage.getItem('username') || "<USER_NAME>";

              if (registration.active) {
                registration.active.postMessage({
                  type: "SESSION_DATA",
                  data: { IMONumber, username, build_version: data.version }
                });
              }
            });

            // ---- Check for waiting SW (already installed but inactive) ----
            if (registration.waiting) {
              console.log('Waiting service worker detected');
              showUpdateBanner(registration.waiting);
            } else {
              registration.update();
            }
          })
          .catch((error) => {
            console.error('Service Worker registration failed:', error);
          });
      })
      .catch(error => {
        console.error('Error fetching version:', error);
      });
  });

  // ---- Listen for SW messages ----
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'SYNC_TIME') {
      sessionStorage.setItem('last-bg-sync-time', event.data.syncTime);
      console.log('Background sync time received:', event.data.syncTime);
    }

    if (event.data?.type === 'UPDATE_READY') {
      // handle broadcasted message from another tab
      showUpdateBanner(event.source as ServiceWorker);
    }
  });

  // ---- Listen for slow network offline events ----
  window.addEventListener('slowNetworkOffline', (event: any) => {
    console.log('Slow network offline event captured, notifying service worker');
    
    navigator.serviceWorker.ready.then((registration) => {
      if (registration.active) {
        registration.active.postMessage({
          type: 'SLOW_NETWORK_OFFLINE',
          data: {
            timestamp: Date.now(),
            details: event.detail || {}
          }
        });
      }
    }).catch((error) => {
      console.error('Failed to send slow network offline message to service worker:', error);
    });
  });
}

function showUpdateBanner(worker: ServiceWorker) {
  const banner = document.getElementById('update-banner');
  const reloadBtn = document.getElementById('reload-btn');
  const dismissBtn = document.getElementById('dismiss-btn');

  if (banner instanceof HTMLElement) {
    banner.style.display = 'block';
  }

  if (reloadBtn && dismissBtn) {
    reloadBtn.onclick = () => {
      if (banner instanceof HTMLElement) {
        banner.style.display = 'none';
      }
      console.log("User accepted update → skipping waiting...");
      worker.postMessage({ type: 'SKIP_WAITING' });

      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log("Controller changed → reloading page");
        window.location.reload();
      });
    };

    dismissBtn.onclick = () => {
      if (banner instanceof HTMLElement) {
        banner.style.display = 'none';
      }
      console.log("User dismissed update banner → keeping current version");
    };
  }
}
